import { Header, AnnouncementBar, Footer } from "@/components/Layout";
import { SITE } from "@/lib/site";
import { useSeo } from "@/lib/seo";

const SECTIONS = [
    {
        h: "Who we are",
        p: `5 Star Construction Services LLC is a licensed general contractor (Oregon CCB #232477) based in Medford, Oregon. We operate this website at 5starhelpme.com to share information about our handyman, repair, and manufactured-home services and to receive contact and quote requests from prospective customers.`,
    },
    {
        h: "What information we collect",
        p: `When you submit our contact form, we collect the name, phone number, optional email address, service category, and message you choose to share. When you call us, we receive your phone number through our carrier. We do not collect Social Security numbers, payment card numbers, government IDs, or any other sensitive personal information through this website.`,
    },
    {
        h: "How we use your information",
        p: `We use the information you submit only to respond to your inquiry, schedule and complete the work you've requested, send a written estimate or invoice, and (if you ask) follow up about future maintenance. We do not sell, rent, or trade your information to third parties.`,
    },
    {
        h: "Cookies & analytics",
        p: `This site uses standard analytics tools (Google Tag, PostHog) to understand which pages visitors use most, so we can improve the site. These tools use cookies and may collect aggregate, non-identifying data such as your approximate location, device type, and which pages you viewed. You can disable cookies in your browser settings at any time without losing access to the site.`,
    },
    {
        h: "How your data is stored",
        p: `Contact form submissions are stored on our hosting provider's servers and forwarded to our business email (5starhelpllc@gmail.com) via a secure email API (Resend). We retain submissions for as long as needed to complete the work and meet recordkeeping requirements, then delete them.`,
    },
    {
        h: "Your choices",
        p: `You may request a copy of any information we hold about you, ask us to correct it, or ask us to delete it by emailing 5starhelpllc@gmail.com or calling 541-292-9620. We will respond within a reasonable time.`,
    },
    {
        h: "Children",
        p: `Our services are intended for adult homeowners, property managers, and businesses. We do not knowingly collect information from anyone under 13 years old.`,
    },
    {
        h: "Changes to this policy",
        p: `If we change this policy, we will update the date below. Continued use of the website after a change means you accept the updated policy.`,
    },
    {
        h: "Contact us",
        p: `Questions about this policy? Call 541-292-9620 or email 5starhelpllc@gmail.com.`,
    },
];

export default function Privacy() {
    useSeo({
        title: "Privacy Policy | 5 Star Construction Services LLC · Medford, Oregon",
        description: "Privacy policy for 5starhelpme.com. What we collect when you contact us, how we use it, and your choices. We don't sell or share your data.",
        path: "/privacy",
    });
    return (
        <div className="bg-[#F6F5F2] min-h-screen">
            <AnnouncementBar />
            <Header />
            <main>
                <section className="bg-[#111111] text-[#F6F5F2] border-b-4 border-[#E11D2A]">
                    <div className="max-w-[1100px] mx-auto px-6 md:px-12 py-16 md:py-20">
                        <div className="font-['Manrope'] text-xs font-bold tracking-[0.22em] uppercase text-[#E11D2A]">Legal</div>
                        <h1 className="mt-3 font-['Anton'] uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
                            Privacy Policy
                        </h1>
                        <p className="mt-5 font-['Manrope'] text-base md:text-lg text-[#F6F5F2]/75 max-w-3xl">
                            Plain-English summary of what we collect, why, and what we do with it. We don&apos;t sell your data. We don&apos;t share it. We use it to do the job you called us about.
                        </p>
                    </div>
                </section>

                <section className="bg-[#F6F5F2]">
                    <div className="max-w-[1100px] mx-auto px-6 md:px-12 py-16 md:py-20">
                        {SECTIONS.map((s) => (
                            <div key={s.h} className="mb-10 last:mb-0">
                                <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight text-[#111812]">{s.h}</h2>
                                <p className="mt-3 font-['Manrope'] text-base md:text-lg text-[#5F5F5F] leading-relaxed">{s.p}</p>
                            </div>
                        ))}

                        <div className="mt-14 pt-8 border-t border-[#E2DFD8]">
                            <div className="font-['Manrope'] text-sm text-[#5F5F5F]">Last updated: December 2025</div>
                            <div className="font-['Manrope'] text-sm text-[#5F5F5F] mt-1">
                                5 Star Construction Services LLC · {SITE.license} · {SITE.city}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
